var i, len, makeTag, name, ref;

makeTag = function(name, attr, content) {
  var html, key, ref, tail, val;
  if (attr == null) {
    attr = {};
  }
  if (content == null) {
    content = '';
  }
  if (typeof attr === 'string') {
    ref = [{}, attr], attr = ref[0], content = ref[1];
  }
  html = "<" + name;
  tail = "</" + name + ">";
  for (key in attr) {
    val = attr[key];
    key = _.escape(key);
    val = _.escape(String(val));
    html += ' ' + key + '="' + val + '"';
  }
  return html + '>' + content + tail;
};

ref = ['a'];
for (i = 0, len = ref.length; i < len; i++) {
  name = ref[i];
  makeTag[name] = _.partial(makeTag, name);
}

module.exports = makeTag;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvY29yZS9mcm9udGVuZC9ncm91cG9uX21vZHVsZXMvbWFrZVRhZy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvYXJpY2h0ZXIvcmVwb3NpdG9yaWVzL3Nscy9jb3JlL2Zyb250ZW5kL2dyb3Vwb25fbW9kdWxlcy9tYWtlVGFnLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLE9BQUEsR0FBVSxTQUFDLElBQUQsRUFBTyxJQUFQLEVBQWtCLE9BQWxCO0FBQ1IsTUFBQTs7SUFEZSxPQUFPOzs7SUFBSSxVQUFVOztFQUNwQyxJQUFpQyxPQUFPLElBQVAsS0FBZSxRQUFoRDtJQUFBLE1BQWtCLENBQUMsRUFBRCxFQUFLLElBQUwsQ0FBbEIsRUFBQyxhQUFELEVBQU8saUJBQVA7O0VBQ0EsSUFBQSxHQUFPLEdBQUEsR0FBSztFQUNaLElBQUEsR0FBTyxJQUFBLEdBQU0sSUFBTixHQUFZO0FBQ25CLE9BQUEsV0FBQTs7SUFDRSxHQUFBLEdBQU0sQ0FBQyxDQUFDLE1BQUYsQ0FBUyxHQUFUO0lBQ04sR0FBQSxHQUFNLENBQUMsQ0FBQyxNQUFGLENBQVMsTUFBQSxDQUFPLEdBQVAsQ0FBVDtJQUNOLElBQUEsSUFBUSxHQUFBLEdBQU0sR0FBTixHQUFZLElBQVosR0FBbUIsR0FBbkIsR0FBeUI7QUFIbkM7U0FJQSxJQUFBLEdBQU8sR0FBUCxHQUFhLE9BQWIsR0FBdUI7QUFSZjs7QUFVVjtBQUFBLEtBQUEscUNBQUE7O0VBQUEsT0FBUSxDQUFBLElBQUEsQ0FBUixHQUFnQixDQUFDLENBQUMsT0FBRixDQUFVLE9BQVYsRUFBbUIsSUFBbkI7QUFBaEI7O0FBS0EsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
